import { render, staticRenderFns } from "./uploadBtn.vue?vue&type=template&id=5ccc9c43&scoped=true"
import script from "./uploadBtn.vue?vue&type=script&lang=js"
export * from "./uploadBtn.vue?vue&type=script&lang=js"
import style0 from "./uploadBtn.vue?vue&type=style&index=0&id=5ccc9c43&prod&lang=less"
import style1 from "./uploadBtn.vue?vue&type=style&index=1&id=5ccc9c43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc9c43",
  null
  
)

export default component.exports